export const EXTERNAL_YT_CHANNEL_CONNECT_E2E_PREFIX =
  'external-yt-channel-connect';
export const YT_ACCOUNT_LINKING_E2E_PREFIX = 'yt-account-linking';
